import './TableActionModal.scss';

import { map, startCase, reduce, noop, camelCase } from 'lodash';
import { bool } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ClickOffSensor from 'components/shared/ClickOffSensor/ClickOffSensor';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import {
  linkBuilder,
  transactions,
  withdrawFromSweepAccount
} from 'services/Externals';
import {
  isBrokerage,
  productMapByNumber,
  isActivePlus
} from 'services/Products';
import { initialState } from 'state/Store';
import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';
import Content from 'services/Content';
import { getSweepAccountsMap } from 'state/account/AccountSelectors';

const brokerageActions = {
    trade: {
      'Trade Stocks & ETFs': 'TRADING',
      'Trade Mutual Funds': 'MF_TRADING',
      'Trade Options': 'OPT_TRADING',
      'Withdraw from Sweep Account': 'SWEEP'
    },
    view: {
      'Order Status': 'ORDERSTATUS',
      'Projected Cash Flow': 'PCF'
    }
  };

const LinkTextCreator = ({ name, label }) => {
  const content = Content.transactions;
  return (
    <div className="table-action-modal-additional-link-subtext table-action-modal-additional-link-subtext-spacing">
      {label === content.label.collegeSavings && name === content.name.exchange
        ? content.collegeSavingsExchange
        : label === content.label.app && name === content.name.exchange
        ? content.activePlusPortfoliosExchange
        : name === content.name.tradeStocks
        ? content.tradeStocks
        : content[camelCase(name)] || ''}
    </div>
  );
};

const linkDestination = (accountId, sweepAccountsMap) => {
  const sweepAccountId = sweepAccountsMap[accountId];
  return sweepAccountId
    ? `${withdrawFromSweepAccount}&selectedAgreementIDs=${sweepAccountId}`
    : withdrawFromSweepAccount;
};

const brokerageClickHandler = (accountId, type, sweepAccountsMap) => {
  type === 'SWEEP'
    ? window.open(linkDestination(accountId, sweepAccountsMap), '_self')
    : openBrokerageAuthTab(accountId, type);
};

const actionLink = (actionName, link, accountId, productType) => {
  //TODO: this is extremely brittle code and needs to be refactored
  return actionName === 'automaticMonthlyContributions' ||
    actionName === Content.transactions.name.otherTransactions ||
    (actionName === 'automaticTransactions' && isActivePlus(productType))
    ? link
    : link.includes('?')
    ? `${link}&selectedAgreementIDs=${accountId}`
    : `${link}?selectedAgreementIDs=${accountId}`;
};

export const ActionsList = ({
  productType,
  accountId,
  classPrefix,
  close = noop,
  sweepAccountsMap,
  uberId,
  view
}) => {
  const actionLinks =
    transactions[initialState.products.byAccount[productType].key];
  const actionLabel = initialState.products.byAccount[productType].label;

  const idActionLinks = reduce(
    actionLinks,
    (idLinks, link, actionName) => ({
      ...idLinks,

      [actionName]: actionLink(actionName, link, accountId, productType)
    }),
    {}
  );

  const BrokerageActionLink = ({ accountId, name, type }) => (
    <li className={`${classPrefix}-link`} key={name}>
      <a
        target="_blank"
        onClick={() => {
          close();
          brokerageClickHandler(accountId, type, sweepAccountsMap);
        }}>
        {name}
      </a>
      <LinkTextCreator name={name} label={actionLabel} />
    </li>
  );

  const BrokerageActionLinkWithPermissions =
    WithUserPermissions(BrokerageActionLink);

  return (
    <div className={`${classPrefix}-links-container`}>
      <ul
        className={`${classPrefix}-${productMapByNumber[productType]}-drop-down-content`}>
        {isBrokerage(productType)
          ? map(brokerageActions.trade, (type, name) => (
              <BrokerageActionLinkWithPermissions
                name={name}
                accountId={accountId}
                type={type}
                sweepAccountsMap={sweepAccountsMap}
                shouldDisable
              />
            ))
          : map(idActionLinks, (link, name) => (
              <li
                key={name}
                className={`${classPrefix}-link action-link-${productMapByNumber[productType]}`}>
                <a
                  href={
                    // Append UBER ID for CWV if it exists
                    initialState.products.byAccount[productType].label ===
                      initialState.productTypes.activePlus.label && uberId
                      ? `${link}&uid=${uberId}`
                      : linkBuilder(link, view)
                  }>
                  {name === 'rollOver' ? (
                    <span>{'Roll Over & Transfer'}</span>
                  ) : (
                    startCase(name)
                  )}
                </a>
                <LinkTextCreator name={name} label={actionLabel} />
              </li>
            ))}
      </ul>
      {isBrokerage(productType) && (
        <ul
          className={`${classPrefix}-${productMapByNumber[productType]}-drop-down-content additional-links`}>
          {map(brokerageActions.view, (type, name) => (
            <BrokerageActionLinkWithPermissions
              name={name}
              accountId={accountId}
              type={type}
              shouldDisable
            />
          ))}
        </ul>
      )}
    </div>
  );
};

const ActionsListWithPermissions = WithUserPermissions(ActionsList);

class TableActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({ show: true });
  }

  close() {
    this.setState({ show: false });
  }

  render() {
    const { productType, accountId, sweepAccountsMap, uberId, view } =
      this.props;
    const { show } = this.state;

    return (
      <ClickOffSensor
        className="table-action-modal"
        isOpen={show}
        onClickOut={this.close}>
        <button
          className={
            'table-action-modal-toggle-modal-button ' + (show ? 'open' : '')
          }
          onClick={show ? this.close : this.open}>
          Actions{' '}
          <span
            className={
              'chevron ' + (show ? 'aa-chevron-up' : 'aa-chevron-down')
            }
          />
        </button>
        {show && (
          <ActionsListWithPermissions
            classPrefix="table-action-modal"
            productType={productType}
            accountId={accountId}
            shouldDisable={false}
            close={this.close}
            sweepAccountsMap={sweepAccountsMap}
            uberId={uberId}
            view={view}
          />
        )}
      </ClickOffSensor>
    );
  }
}

TableActionModal.propTypes = {
  hasActivePlus: bool,
  hasCollegeSavings: bool,
  hasMutualFunds: bool
};

const mapStateToProps = (state) => ({
  view: state.view,
  sweepAccountsMap: getSweepAccountsMap(state),
  uberId: state.customer.webViewEnabled ? state.customer.uberId : ''
});

export default connect(mapStateToProps)(TableActionModal);
